import styles from './ActivityIndicator.module.css';

interface ActivityIndicatorProps {
  visible?: boolean;
}

export function ActivityIndicator({ visible = false }: ActivityIndicatorProps) {
  if (!visible) return null;

  return (
    <div className={styles.overlay}>
      <div className={styles.spinner}></div>
    </div>
  );
}

export default ActivityIndicator;
